
// src/components/Papers/PaperCard.jsx
import React, { useState } from 'react';
import { ExternalLink } from 'lucide-react';

export const PaperCard = ({ paper, searchQuery }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const highlightText = (text, query) => {
        if (!query) return text;
        const queries = query.split(' ');
        let highlightedText = text;

        queries.forEach(q => {
            if (!q) return;
            const regex = new RegExp(`(${q})`, 'gi');
            highlightedText = highlightedText.replace(regex, '<mark class="bg-yellow-200">$1</mark>');
        });

        return <span dangerouslySetInnerHTML={{ __html: highlightedText }} />;
    };

    const ABSTRACT_MAX_LENGTH = 300;
    const isLongAbstract = paper.abstract.length > ABSTRACT_MAX_LENGTH;

    return (
        <div className="bg-white rounded-lg shadow-sm p-6 mb-4">
            <div className="flex justify-between items-start">
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                    {highlightText(paper.title, searchQuery)}
                </h3>
                <a
                    href={`https://arxiv.org/abs/${paper.arxiv_id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary-600 hover:text-primary-700"
                >
                    <ExternalLink className="w-5 h-5" />
                </a>
            </div>

            <div className="flex gap-2 flex-wrap mb-3">
                {(Array.isArray(paper.categories) ? paper.categories :
                    typeof paper.categories === 'string' ? JSON.parse(paper.categories) :
                        []
                ).map((category, index) => (
                    <span
                        key={index}
                        className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-primary-100 text-primary-800"
                    >
                        {category}
                    </span>
                ))}
            </div>

            <div className="text-sm text-gray-500 mb-3">
                <p className="mb-1">Authors: {paper.authors.join(', ')}</p>
                <p>Published: {new Date(paper.first_version_date).toLocaleDateString()}</p>
            </div>

            <div className="text-sm text-gray-700">
                {highlightText(
                    isExpanded ? paper.abstract :
                        isLongAbstract ? paper.abstract.slice(0, ABSTRACT_MAX_LENGTH) + "..." :
                            paper.abstract,
                    searchQuery
                )}
                {isLongAbstract && (
                    <button
                        onClick={() => setIsExpanded(!isExpanded)}
                        className="ml-2 text-primary-600 hover:text-primary-700 font-medium"
                    >
                        {isExpanded ? 'Show less' : 'Show more'}
                    </button>
                )}
            </div>
        </div>
    );
};